const CorrectPickupInfo = React.lazy(() => import("../CorrectPickupInfo"));
const OptimizationSolution = React.lazy(() =>
  import("../ReviewOptimizationSolution")
);
const Benefits = React.lazy(() => import("../Benefits"));

const OptimizationStepContent = ({ step, props }) => {
  const componentByStep = {
    0: <CorrectPickupInfo {...props}/>,
    1: <OptimizationSolution {...props}/>,
    2: <Benefits {...props}/>
  }
  return componentByStep[step] || <span>Unknown step</span>;
};

export default OptimizationStepContent;
